import React from 'react';
import GallectionsListView from './GallectionsListView';
import GallectionsListViewContainer, {
  OwnProps,
} from './GallectionsListView.container';

export default GallectionsListViewContainer(
  GallectionsListView
) as React.ComponentType<OwnProps>;
